import React, { FC } from 'react';
import PortalHeader from './portal-header';

const QuestionnaireLoadingState: FC = () => (
  <div className="adhd-portal min-h-screen flex flex-col bg-page">
    <PortalHeader />
    <div className="flex-1 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-sm border border-slate-200 p-8">
        <div className="flex flex-col items-center mb-6">
          <div className="relative w-14 h-14 mb-4">
            <span
              className="absolute inset-0 rounded-full animate-ping opacity-20 bg-brand"
            />
            <span
              className="absolute inset-0 rounded-full animate-spin border-[3px] border-brand border-b-transparent border-l-transparent"
            />
            <span
              className="absolute inset-2 rounded-full flex items-center justify-center bg-brand bg-opacity-10"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-brand" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
                <rect x="9" y="3" width="6" height="4" rx="1" />
              </svg>
            </span>
          </div>
          <h3 className="text-base font-bold text-slate-800 mb-1">
            Preparing your assessment
          </h3>
          <p className="text-xs text-slate-400 text-center">
            Loading your questionnaire — this will only take a moment
          </p>
        </div>
        <div className="space-y-3">
          {[{ w: 85, d: 0 }, { w: 100, d: 150 }, { w: 65, d: 300 }].map(({ w, d }) => (
            <div key={`skel-q-${w}`} className="flex items-center gap-3">
              <div
                className="w-5 h-5 rounded-md animate-pulse flex-shrink-0 bg-slate-200"
                style={{ animationDelay: `${d}ms` }}
              />
              <div
                className="h-3 rounded-full animate-pulse bg-slate-200"
                style={{ width: `${w}%`, animationDelay: `${d}ms` }}
              />
            </div>
          ))}
          <div className="pt-2 space-y-2">
            {[{ w: 45, d: 450 }, { w: 70, d: 600 }, { w: 55, d: 750 }, { w: 90, d: 900 }].map(({ w, d }) => (
              <div
                key={`skel-l-${w}`}
                className="h-2.5 rounded-full animate-pulse bg-slate-100"
                style={{ width: `${w}%`, animationDelay: `${d}ms` }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default QuestionnaireLoadingState;
